<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('qualitylayer_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-quality-high</v-icon>{{ item['height'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-qualitylayer-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.quality.height') }}</strong></td>
              <td>
                {{ $n(item['height']) }}              </td>

              <td></td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'QualityLayer';

export default {
  name: 'QualityLayerShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('qualitylayer', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('qualitylayer', ['find'])
  },
  methods: {
    ...mapActions('qualitylayer', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
